export default __webpack_public_path__ + "static/media/619.c2fc1dff.png";